module.exports = __webpack_public_path__ + "img/template_image_placeholder.8865f01b.jpg";